import React, { Component } from "react";
import { Modal, Form, Row, Col, Divider, Button } from "antd";
import InputForm from "./InputForm";
import { checkFormIsValid, validateSelect } from '../utils/Validator';
import "./CotacoesForm.css";
import "../index.css";
// import NumberFormat from 'react-number-format';
import axios from 'axios';
import moment from 'moment-timezone';

const { Item: ItemForm } = Form;

export default class CotacoesForm extends Component {

  state = {
    cotacao: {},
    marcas: [],
  };

  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.cotacaoSelecionada !== propsAnterior.cotacaoSelecionada) {
      this.setState({
        cotacao: this.props.cotacaoSelecionada
      }, () => {
        // this.refs.compras_cfr_marca.focus();
      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    console.log({ id, value })

    const { cotacao } = this.state;
    cotacao[id] = value;

    this.setState({
      [id]: value
    });
  };

  onOK = () => {
    if (checkFormIsValid(this.refs)) {
      const { cotacao } = this.state;
      cotacao.compras_cfr_marca = cotacao.marca.key;
      this.props.onSalvarClick(cotacao);
    }
  };



  buscaMarcas = (value) => {
    this.setState({ buscandoMarcas: true, marcas: [] })

    console.log(value);

    axios.get('/marcas', {
      params: {
        descricao: value,
        limite: 10
      }
    }).then(response => {
      const { data } = response.data;

      console.log(data.map);

      const marcas = data.map(marca => {
        return {
          key: marca.estoq_mar_codigo,
          label: marca.estoq_mar_descricao
        }
      });

      this.setState({
        marcas,
        buscandoMarcas: false,
      })
    }).catch(error => {
      console.warn(error);
      this.setState({
        buscandoMarcas: false,
      })
    })
  }

  renderStatus = (cotacao) => {
    if (cotacao.compras_cfr_ganhou_cotacao === 'S') {
      console.warn('Venceu');
      return 'Venceu';
    }
    if (cotacao.compras_cfi_flag_situacao === 'A') {
      console.warn('Pendente');
      return 'Pendente';
    }
    if (cotacao.compras_cfi_flag_situacao === 'R') {
      console.warn('Retornado');
      return 'Retornado';
    }
    return '';
  };


  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { compras_cot_codigo, estoq_ie_descricao, compras_ci_item, compras_cfr_qtde_ret,
      compras_cfr_preco_avista, compras_cfr_preco_prazo, compras_cfr_desconto,
      compras_cfr_impostos, compras_cfr_prazo_entrega, compras_ci_qtde_sugerida,
      compras_cot_data_encerramento, marca } = this.state.cotacao;
    const { marcas, buscandoMarcas, cotacao } = this.state;
    const estaInativo = moment(compras_cot_data_encerramento).isBefore(moment());
    return (
      <Modal
        title="Retorno da Cotação"
        visible={visivel}
        className="tituloForm"
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
      >
        <Form>
          <Row>
            <Row>
              <Col xs={24} sm={5}>
                <InputForm
                  id="compras_cot_codigo"
                  label="Cotação"
                  value={compras_cot_codigo}
                  disabled
                />
              </Col>
              <Col xs={1} />
              <Col xs={24} sm={6}>
                <InputForm
                  id="descricaoStatus"
                  label="Status"
                  // value={compras_cfi_flag_situacao}
                  value={this.renderStatus(cotacao)}
                  disabled
                />
              </Col>
              <Col xs={1} />
              <Col xs={24} sm={5}>
                <InputForm
                  label="Quantidade"
                  id="compras_ci_qtde_sugerida"
                  ref="compras_ci_qtde_sugerida"
                  type="number"
                  value={compras_ci_qtde_sugerida}
                  disabled
                />
              </Col>
              <Col xs={1} />
              <Col xs={24} sm={5}>
                <InputForm
                  id="compras_ci_item"
                  label="Cód. Produto"
                  value={compras_ci_item}
                  disabled
                />
              </Col>
              <Col xs={24}>
                <InputForm
                  id="estoq_ie_descricao"
                  label="Descrição do Produto"
                  value={estoq_ie_descricao}
                  disabled
                />
              </Col>
            </Row>

            <Divider orientation="left">Dados do Retorno do Fornecedor</Divider>

            <Row>
              <Col xs={24}>

                <InputForm
                  // mode="multiple"
                  type="select"
                  id="marca"
                  ref="marca"
                  value={marca}
                  showSearch
                  placeholder="Selecione a marca"
                  onSearch={this.buscaMarcas}
                  onChange={this.onChange}
                  data={marcas}
                  fetching={buscandoMarcas}
                  validator={validateSelect}
                  disabled={estaInativo}
                  required
                  errorMessage="Campo obrigatório"
                />
              </Col>

              <Col xs={24} sm={8}>
                <InputForm
                  label="Quantidade"
                  id="compras_cfr_qtde_ret"
                  ref="compras_cfr_qtde_ret"
                  type="number"
                  value={compras_cfr_qtde_ret}
                  onChange={this.onChange}
                  required
                  disabled={estaInativo}
                  errorMessage="Campo obrigatório"
                />
              </Col>
              <Col xs={1} />
              <Col xs={24} sm={7}>
                <InputForm
                  label="Preço à Vista"
                  id="compras_cfr_preco_avista"
                  ref="compras_cfr_preco_avista"
                  type="number"
                  value={compras_cfr_preco_avista}
                  onChange={this.onChange}
                  required
                  disabled={estaInativo}
                  errorMessage="Campo obrigatório"
                />
              </Col>
              <Col xs={1} />
              <Col xs={24} sm={7}>
                <InputForm
                  label="Preço à Prazo"
                  id="compras_cfr_preco_prazo"
                  ref="compras_cfr_preco_prazo"
                  type="number"
                  value={compras_cfr_preco_prazo}
                  onChange={this.onChange}
                  required
                  disabled={estaInativo}
                  errorMessage="Campo obrigatório"
                />
              </Col>

              <Col xs={24} sm={8}>
                <InputForm
                  label="Desconto(%)"
                  id="compras_cfr_desconto"
                  ref="compras_cfr_desconto"
                  type="number"
                  value={compras_cfr_desconto}
                  onChange={this.onChange}
                  disabled={estaInativo}
                  errorMessage="Campo obrigatório"
                />
              </Col>
              <Col xs={1} />
              <Col xs={24} sm={7}>
                <InputForm
                  label="Impostos(%)"
                  id="compras_cfr_impostos"
                  ref="compras_cfr_impostos"
                  type="number"
                  value={compras_cfr_impostos}
                  onChange={this.onChange}
                  disabled={estaInativo}
                  errorMessage="Campo obrigatório"
                />
              </Col>
              <Col xs={1} />
              <Col xs={24} sm={7}>
                <InputForm
                  id="compras_cfr_prazo_entrega"
                  ref="compras_cfr_prazo_entrega"
                  label="Prazo Entrega(Dias)"
                  type="number"
                  decimalScale={0}
                  value={compras_cfr_prazo_entrega}
                  onChange={this.onChange}
                  disabled={estaInativo}
                  errorMessage="Campo obrigatório"
                />
              </Col>
            </Row>
            <ItemForm>
              <Row>
                <Col xs={24}>
                  {!estaInativo ? (
                    <Button
                      type="primary"
                      htmlType="button"
                      loading={carregando}
                      onClick={this.onOK}
                      className="botoesModalForm"
                    >
                      Salvar
                </Button>
                  ) : null}
                  <Button
                    htmlType="button"
                    onClick={onCancelarClick}
                    className="botoesModalForm"
                  >
                    Cancelar
                </Button>
                </Col>
              </Row>
            </ItemForm>
          </Row>
        </Form>
      </Modal>
    );
  }
}






// WEBPACK FOOTER //
// ./src/components/CotacoesForm.js